import { useAsyncAction } from "shared/lib/useAsyncAction"
import { useEvent } from "shared/lib/useEvent"

import { TeamInvitationStatus } from "entities/team-invitations/types/TeamInvitationStatus"

import { ProjectTeamInvitationCardProps } from "../ProjectTeamInvitationCard"
import { ProjectTeamInvitationCardViewModel } from "../ui/ProjectTeamInvitationCardView"

export function useProjectTeamInvitationCardViewModel({
  teamInvitation,
  onReject,
  onAccept,
  onNavigateToProject,
  ...rest
}: ProjectTeamInvitationCardProps): ProjectTeamInvitationCardViewModel {
  const { isLoading: isAccepting, execute: handleAcceptWithLoading } =
    useAsyncAction(onAccept)
  const handleAccept = useEvent(() => {
    handleAcceptWithLoading?.(teamInvitation)
  })

  const { isLoading: isRejecting, execute: handleRejectWithLoading } =
    useAsyncAction(onReject)
  const handleReject = useEvent(() => {
    handleRejectWithLoading?.(teamInvitation)
  })

  const handleNavigateToProject = useEvent(() => {
    if (teamInvitation.team.projects?.[0]?.id) {
      onNavigateToProject?.(teamInvitation.team.projects[0]?.id)
    }
  })

  const canNavigateToProject =
    !!onNavigateToProject &&
    !!teamInvitation.team.projects?.[0]?.id &&
    teamInvitation.status === TeamInvitationStatus.ACCEPTED

  return {
    ...rest,
    teamInvitation,
    isAccepting: isAccepting || rest.isAccepting,
    isRejecting: isRejecting || rest.isRejecting,
    handleReject: onReject ? handleReject : undefined,
    handleAccept: onAccept ? handleAccept : undefined,
    handleNavigateToProject: canNavigateToProject
      ? handleNavigateToProject
      : undefined
  }
}
